module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('refresh', {
    staticClass: ["dof-refresher"],
    attrs: {
      "display": _vm.refreshing ? 'show' : 'hide'
    },
    on: {
      "refresh": _vm.onRefresh,
      "pullingdown": _vm.onPullingDown
    }
  }, [(_vm.refreshing) ? _c('midea-apng-view', {
    staticClass: ["indicator"],
    attrs: {
      "loop": true,
      "auto": true,
      "src": _vm.loadingIcon
    }
  }) : _vm._e(), (_vm.refresherText) ? _c('text', {
    staticClass: ["u-txt"]
  }, [_vm._v(_vm._s(_vm.refresherText))]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-01843725!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-refresher/index.vue
// module id = 567
// module chunks = 0 1